import type * as React from "react";

import noop from "lodash/noop";

import { BasicModal, Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { confirmDefaultModalConfig, getCloseButtonConfig, getConfirmButtonConfig } from "./configs";
import * as SC from "./styles";
import { CONFIRM_DEFAULT_ACTIVATION_MODAL_CONTENT, CONFIRM_DEFAULT_ACTIVATION_MODAL_TITLE } from "./texts";

type ConfirmDefaultActivationModalSchema = {
    isOpen: boolean;
    onCloseClick: () => void;
    onUpdateDefaultActivation: () => void;
    isLoading: boolean;
    selectedName: string;
};

const ConfirmDefaultActivationModal = ({
    isOpen,
    onCloseClick,
    onUpdateDefaultActivation,
    isLoading,
    selectedName,
}: ConfirmDefaultActivationModalSchema) => {
    const onClose = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();
        onCloseClick();
    };

    const onUpdateClick = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();
        onUpdateDefaultActivation();
    };

    return (
        <BasicModal
            isOpen={isOpen}
            onRequestClose={onCloseClick}
            shouldCloseOnOverlayClick
            customStyles={confirmDefaultModalConfig}
            closeIconConfig={{
                show: false,
                onClick: noop,
            }}
        >
            <SC.Wrapper>
                <SC.ContentWrapper>
                    <SC.Title>{translate(CONFIRM_DEFAULT_ACTIVATION_MODAL_TITLE)}</SC.Title>
                    <SC.Content>
                        {translate(CONFIRM_DEFAULT_ACTIVATION_MODAL_CONTENT, { name: selectedName })}
                    </SC.Content>
                </SC.ContentWrapper>

                <SC.ButtonsWrapper>
                    <SC.StyledButton
                        {...getCloseButtonConfig()}
                        onClick={onClose}
                    />

                    <Button
                        {...getConfirmButtonConfig()}
                        onClick={onUpdateClick}
                        isLoading={isLoading}
                    />
                </SC.ButtonsWrapper>
            </SC.Wrapper>
        </BasicModal>
    );
};

export default ConfirmDefaultActivationModal;
